export default __webpack_public_path__ + "static/media/next-arrow.f49bb668.svg";